<template lang="pug">
  BaseTable(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :table="table"
    :items="items"
    :meta="meta"
    :sort="sort"
    :page="page"
    :onDelete="onDelete"
    :toggleSort="toggleSort"
    :changePage="changePage"
  )
</template>

<script>
import BaseTable from '@/components/app/BaseTable'
import store from '@/store'
import { mapState, mapMutations } from 'vuex'

export default {
  components: { BaseTable },
  data: vm => ({
    title: vm.$t('news.categories.title')
  }),
  computed: {
    ...mapState('newsCategories', ['routeKey', 'routes', 'table', 'items', 'meta', 'sort', 'page']),
    crumbs: vm => [
      { text: vm.$t('news.title'), to: { name: 'news.index' } },
      { text: vm.$t('news.categories.title') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('newsCategories/fetchItems')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapMutations('newsCategories', ['SET_SORT', 'SET_PAGE']),
    async onDelete (id) {
      await store.dispatch('newsCategories/deleteItem', { id })
      await store.dispatch('newsCategories/fetchItems')
      this.$notify({ message: this.$t('forms.notify.deleted') })
    },
    async toggleSort (field) {
      this.SET_SORT(field)
      await store.dispatch('newsCategories/fetchItems')
    },
    async changePage (page) {
      this.SET_PAGE(page)
      await store.dispatch('newsCategories/fetchItems')
    }
  }
}
</script>
